'use client'

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export default async function goToLocation(
  router: AppRouterInstance,
  queryParams?: URLSearchParams
) {
  const { push } = router

  const search = queryParams?.toString()
  const url = search ? `/location2?${search}` : '/location2'

  push(url, { scroll: false })
}
